export interface AcademicOccurrences {
  id: number;
  observation: string;
  occurrence_type_id: number;
  occurrence_type: AcademicOccurrencesType[];
  occurrence_date: Date;
}

export interface AcademicOccurrencesType {
  id: number;
  description: string;
  title: string;
}

export interface Recomendations {
  id: number;
  description: string;
  language_id: number;
  type: number;
}

export interface RecomendationsByType {
  responsible: Recomendations[];
  student: Recomendations[];
  school: Recomendations[];
}

export interface RecomendationsIds {
  responsible_recomendations_id: number[];
  student_recomendations_id: number[];
  school_recomendations_id: number[];
}

export interface Bimesters {
  ano: number;
  bimestre: number;
  data_fim: string;
  data_inicio: string;
  data_liberacao: string;
  descricao: string;
  dias_letivos: number | null;
  entidade_id: number;
  id: number;
  tipo_periodo: number;
}

export interface StudentEducationalOccurrences {
  recomendations: RecomendationsIds;
  responsiblesEmail: string[];
  subjects: OccurrencesSubjects[];
}
export interface OccurrencesSubjects {
  date_email_sent: string | null;
  educational: number;
  email_sent: number;
  entity_id: number;
  group_id: number;
  id: number;
  observation: string;
  occurrence_date: string;
  occurrence_type_id: number;
  responsible: number;
  student_id: number;
  subject_id: number;
  type?: number;
  created_at?: string;
  updated_at?: string;
  subject?: Subject;
  occurrence_type_description?: string;
}

export interface Subject {
  id: number;
  descricao: string;
}

export interface OccurrencesType {
  id: number;
  description: string;
  language_id: number;
  status: number;
  title: string | null;
  type: number;
  created_at: string;
  updated_at: string;
}

export interface FilterEducationalData {
  type: number;
  student_id: number;
  start_date: string;
  end_date: string;
}

export interface SendEmailData {
  occurrences_id: number[];
  letter_id: number;
  initial_date: string;
  final_date: string;
  entity_id: number;
}

export interface StudentOccurrenceGetData {
  student_id: number;
  entity_id: number;
  initial_date?: string;
  final_date?: string;
  bimester_id?: number;
}

export interface UpdateStudentOnScreenOccurrenceData {
  students_id: string | string[];
  entity_id: number;
  initial_date: string;
  final_date: string;
}
export interface SaveOccurrenceData {
  appointments: Appointments[];
}

export interface Appointments {
  batch: number;
  educational: number;
  entity_id: number;
  group_id: number;
  letter_id: number;
  observation: string;
  occurrence_date: string;
  occurrence_type_id: number;
  recomendations_id: number[];
  sendMail: number;
  student_id: string;
  subject_id?: number;
}

export interface OccurrencesPopoverData {
  emails: string[];
  observation: string;
  date_sent: string;
}

export interface OccurrenceStudentSummary {
  group_by: string;
  id: number;
  name: string;
  photo: string;
  pcd: number;
  necessidades_especiais: StudentSpecialNeeds[];
  educational_occurrences: number;
  disciplinary_occurrences: number;
}
export interface StudentSpecialNeeds {
  id: number;
  descricao: string;
  adms_id: string;
}

export interface LetterOccurrence {
  id: number;
  entity_id: number;
  paragraph_one: string;
  paragraph_two: string;
  suspension: number;
  title: string;
  type_letter: number;
}

export interface AcademicNotifications {
  id: number;
  description: string;
  displinary_notification_occurrence: DisciplinareNotificationOccurrence;
  entity_id: number;
  group_id: number;
  letter: LetterOccurrence;
  letter_id: number;
  release_date: string;
  return_date: string;
  returned: number;
  student_id: number;
  created_at?: string;
  updated_at?: string;
}

export interface AcademicNotificationsData {
  notification: any;
  student_id: number;
}

export interface StudentNotifications {
  id: number;
  date: string;
  observation: string;
  occurrence_type_name: string;
  subject_id: number;
  subject_name: string;
}

export interface DisciplinareNotificationOccurrence {
  id: number;
  disciplinary_notification_id: number;
  occurrence_id: number;
  created_at?: string;
  updated_at?: string;
}
